var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPopupLogin)?_c('div',{staticClass:"c-login-page"}):_c('CircularProgress',{attrs:{"message":_vm.$t('message.loggingIn'),"page":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }